import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Divider,
  Col,
  Collapse,
  Statistic,
  Dropdown,
} from "antd";
import {
  SettingOutlined,
  DownloadOutlined,
  UploadOutlined,
  CalculatorOutlined,
  HolderOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import "../../../../assets/styles/DatePicker.css";
import tabList from "./tabs/tabList.json";
import MainLayout from "../../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import Memo from "./tabs/Memo";
import Transactions from "./tabs/transactions/Transactions";
import Charges from "./tabs/charges/Charges";
import { rightAction } from "../../../../redux/actions";
import {
  AccountFacility,
  handleFlgStatus,
  handleSavingsAccActionButtons,
  AmountFormat,
  accountStatus,
  handleFlgSubStatus,
} from "../../../../components/facilities/AccountFacility";
import Notiflix from "notiflix";
import ManageStandingInstructions from "./tabs/standingInstructions/ManageStandingInstructions";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const items = [
  {
    label: "Post Interest As On",
    key: "1",
    route: "/post-interest",
    disabled: true,
    icon: <DoubleRightOutlined />,
  },
  {
    label: "Deposit",
    key: "2",
    route: "/deposit",
    disabled: true,
    icon: <UploadOutlined />,
  },
  {
    label: "Withdraw",
    key: "3",
    route: "/withdraw",
    disabled: true,
    icon: <DownloadOutlined />,
  },
  {
    label: "Calculate Interest",
    key: "4",
    route: "/calculate-interest",
    disabled: true,
    icon: <CalculatorOutlined />,
  },
  {
    label: "Hold",
    key: "5",
    route: "/hold",
    disabled: true,
    icon: <HolderOutlined />,
  },
  {
    label: "Assign Staff",
    key: "6",
    route: "/assign-staff",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Post Interest",
    key: "7",
    route: "/post-interest",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Add Charge",
    key: "8",
    route: "/add-charge",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Close",
    key: "9",
    route: "/close-savings",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Manage Account",
    key: "10",
    route: "/manage-account",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "KYC",
    key: "11",
    route: "/passfort",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Transfer Funds",
    key: "12",
    route: "/transfer-funds",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Modify Application",
    key: "13",
    route: "/placeholder",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Approve",
    key: "14",
    route: "/placeholder",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Reject",
    key: "15",
    route: "/placeholder",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Withdrawn by client",
    key: "16",
    route: "/placeholder",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Add Charge",
    key: "17",
    route: "/placeholder",
    disabled: true,
    icon: <SettingOutlined />,
  },
  {
    label: "Delete",
    key: "18",
    route: "/placeholder",
    disabled: true,
    icon: <SettingOutlined />,
  },
];

const SavingsAccountDetails = (props) => {
  //DECLARED VARIABLES
  const { userData, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();

  const { state } = useLocation();
  const [useForm] = Form.useForm();

  const [accountDetails, setAccountDetails] = useState([]);
  const [chargesList, setChargesList] = useState([]);
  const [transactionsList, setTransactionsList] = useState([]);
  const [memoList, setMemoList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("transactions");
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCount, setTableCount] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [clientOfficeData, setClientOfficeData] = useState({
    officeId: "",
    officeName: "",
  });
  const [menuProps, setMenuProps] = useState({
    items: [],
  });

  const tabList = [
    {
      key: "transactions",
      label: "Transactions",
    },
    {
      key: "charges",
      label: "Charges",
      disabled: !BOM.HasPermission("READ_SAVINGSACCOUNTCHARGE"),
    },
    {
      key: "memo",
      label: "Memo",
      disabled: !BOM.HasPermission("READ_SAVINGNOTE"),
    },
    {
      key: "standingInstruction",
      label: "Standing Instructions",
      // disabled: !BOM.HasPermission("READ_SAVINGNOTE")
    },
  ];

  useEffect(() => {
    console.log(state);

    getClientById();

    // getDetailById();
    {
      BOM.HasPermission("READ_SAVINGNOTE") && getNotes();
    }
  }, []);

  const getClientById = () => {
    const url = `${apiConfig.Clients}/${state.clientId}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let temp = {
          officeId: objList.officeId,
          officeName: objList.officeName,
        };

        console.log(temp);

        setClientOfficeData(temp);

        getDetailById(temp, 0, Number(tableCount));
      }
    });
  };

  const getDetailById = (temp = clientOfficeData, offset = 0, _limit = Number(tableCount)) => {
    const params = {
      associations: "all",
      offset: offset,
      limit: _limit,
    };

    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setAccountDetails(objDetail);
        setTotalItems(objDetail?.transactionSize);
        // console.log(objDetail);

        let tempInterestRateChartArray = [];
        let tempChargesArray = [];
        let tempTransactionsArray = [];

        objDetail?.accountChart?.chartSlabs?.forEach((element) => {
          tempInterestRateChartArray.push({
            key: element?.id,
            id: element?.id,
            periodType: element?.periodType ? element?.periodType?.value : "-",
            periodFromTo: `${element?.fromPeriod} - ${element?.toPeriod}`,
            amountRange: element?.amountRangeFrom ? element?.amountRangeFrom : "-",
            interest: element?.annualInterestRate ? element?.annualInterestRate : "-",
          });
        });

        objDetail?.charges?.forEach((element) => {
          tempChargesArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? BOM.SubstringFormat(element?.name, 20) : "-",
            penalty: element?.penalty ? "Penalty" : "Fee",
            paymentDueAt: element?.chargeTimeType?.value ? element?.chargeTimeType?.value : "-",
            dueAsOf: element?.dueDate ? BOM.DateTime(element?.dueDate, "only-date") : "-",
            repeatsOn: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",
            calculationType: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            due: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountOrPercentage}`
              : "-",
            paid: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountPaid}`
              : "-",
            waived: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountWaived}`
              : "-",
            outstanding: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountOutstanding}`
              : "-",
            status: handleFlgStatus(element?.isActive ? "active" : "closed", {}, true),
          });
        });

        objDetail?.transactions?.forEach((element) => {
          tempTransactionsArray.push({
            key: element?.id,
            id: element?.id,
            transactionDate: element?.date ? BOM.DateTime(element?.date, "only-date") : "-",
            transactionType: element?.transactionType ? element?.transactionType?.value : "-",
            amount: element.amount,
            balance: element?.runningBalance
              ? `${element?.currency?.code} ${element?.runningBalance}`
              : "-",
            transactionTypeDetail: element.transactionType,
          });
        });

        setChargesList(tempChargesArray);
        setTransactionsList(tempTransactionsArray);

        /**
         * ON CLICK ACTION MENU
         */
        setMenuProps({
          items: handleSavingsAccActionButtons(objDetail),
          onClick: (e) => {
            console.log(e);

            const item = handleSavingsAccActionButtons(objDetail).find(
              (element) => element.key === e.key,
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "calculate interest":
                  return calculateInterest();
                case "post interest":
                  return postInterest();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      accountNo: objDetail.accountNo,
                      actionLabel: item.label,
                      branchId: temp.officeId,
                      savingsProductId: objDetail.savingsProductId,
                    },
                  });
              }
            }

            // if (item) {
            //   return navigate(item.route, {
            //     state: {
            //       ...state,
            //       accountNo: objDetail.accountNo,
            //       actionLabel: item.label,
            //     },
            //   });
            // }
          },
        });
        /**
         * ACTIVATE DELETE RIGHT BUTTON ACTION
         */
        if (
          objDetail?.status?.value.toLowerCase() === accountStatus.submittedAndPending &&
          BOM.HasPermission("DELETE_SAVINGSACCOUNT")
        ) {
          rightAction(cnt.RIGHT_DELETE_BTN);
        }

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    getDetailById(clientOfficeData, offset, limit);
    setCurrentPage(1);
  };

  const getNotes = () => {
    setIsLoading(true);

    const url = `${apiConfig.Savings}/${state.id}/notes`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // setAccountDetails(objDetail);

        let tempMemoArray = [];

        objDetail?.forEach((element) => {
          tempMemoArray.push({
            key: element?.id,
            memoId: element?.id,
            createdBy: element?.createdByUsername ? element?.createdByUsername : "-",

            memo: element?.note ? element?.note : "-",
            createdOn: element?.createdOn ? BOM.DateTime(element?.createdOn, "only-date") : "-",
          });
        });
        setMemoList(tempMemoArray);

        setIsLoading(false);
      }
    });
  };

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  //OTHER SAVINGS ACCOUNT ACTION
  const handleOnDelete = () => {
    let action = "Delete Account  ";
    let accountNo = accountDetails.accountNo;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + accountNo,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.savingsAccounts}/${state.id}`;
        let body = {
          session,
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, "Savings Account was successfully deleted");
              navigate("/acc0102");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/detail-savings-account", { state: { ...state } });
              setIsLoading(false);
            },
          },
        );
      },

      function () {
        // No button
      },
    );
  };
  function postInterest() {
    setIsLoading(true);
    const params = {
      command: "postInterest",
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
      method: "POST",
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Savings Account Interest was succesfully posted");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-savings-account", { state: { ...state } });
          setIsLoading(false);
        },
      },
    );
  }
  function calculateInterest() {
    setIsLoading(true);
    const params = {
      command: "calculateInterest",
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
      method: "POST",
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Savings Account Interest was succesfully calculated");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-savings-account", { state: { ...state } });
          setIsLoading(false);
        },
      },
    );
  }

  const contentListNoTitle = {
    transactions: (
      <Transactions
        currentPage={currentPage}
        tableCount={tableCount}
        totalItems={totalItems}
        setCurrentPage={setCurrentPage}
        onRefresh={onRefresh}
        transactionsList={transactionsList}
        state={state}
        userData={userData}
      />
    ),
    charges: (
      <Charges
        chargesList={chargesList}
        setChargesList={setChargesList}
        state={state}
        userData={userData}
        refreshDetail={getDetailById}
        refreshNote={getNotes}
      />
    ),
    memo: (
      <Memo
        memoList={memoList}
        useForm={useForm}
        state={state}
        userData={userData}
        setMemoList={setMemoList}
        getNotes={getNotes}
      />
    ),
    standingInstruction: (
      <ManageStandingInstructions
        useForm={useForm}
        state={state}
        userData={userData}
        clientOfficeData={clientOfficeData}
      />
    ),
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailSavingsAccount}
        pageItems={staticConfig.detailSavingsAccountBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button menu={menuProps} icon={<SettingOutlined />} placement="topLeft">
                  Actions
                </Dropdown.Button>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <AccountFacility
                  accountName={accountDetails?.clientName}
                  productName={accountDetails?.savingsProductName}
                  accountNo={accountDetails?.accountNo}
                  status={accountDetails?.status}
                  subStatus={accountDetails?.subStatus}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 30 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.currentBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.accountBalance}
                    precision={2}
                  />
                </Card>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.availableBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.availableBalance}
                    precision={2}
                  />
                </Card>
              </Col>
            </Row>

            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <SavingsDetails accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <PerformanceHistory accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <InterestDetails accountDetails={accountDetails} />
              </Col>
            </Row>
          </Form>
        </Card>
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(SavingsAccountDetails);

function SavingsDetails(props) {
  const { accountDetails } = props;
  const displayFields = [
    {
      name: labelConfig.activationDate,
      value: BOM.FormatArrayDate(accountDetails?.timeline?.activatedOnDate),
      position: "top",
    },
    // {
    //   name: labelConfig.bban,
    //   value: accountDetails?.externalId ? accountDetails?.externalId : "-",
    //   position: "middle",
    // },
    {
      name: labelConfig.depositIban,
      value: accountDetails?.externalId ? accountDetails?.externalId : "-",
      position: "middle",
    },
    {
      name: labelConfig.interestRate,
      value: accountDetails?.interestRate?.value ? accountDetails?.interestRate?.value : "-",
      position: "middle",
    },
    {
      name: labelConfig.currency,
      value: accountDetails?.currency?.name
        ? `${accountDetails?.currency?.name}(${accountDetails?.currency?.code})`
        : "-",
      position: "middle",
    },
    {
      name: labelConfig.accountOfficer,
      value: accountDetails?.fieldOfficerName ? accountDetails?.fieldOfficerName : "-",
      position: "middle",
    },
    {
      name: labelConfig.status,
      value: accountDetails?.status?.value ? accountDetails?.status?.value : "-",
      position: "bottom",
    },
  ];

  const getStyleBasedOnPosition = (position) => {
    switch (position.toLowerCase()) {
      case "top":
        return {
          border: "2px solid #F5F5F5",
          borderRadius: 15,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomColor: "#E2E2E2",
        };
      case "bottom":
        return {
          border: "2px solid #F5F5F5",
          borderRadius: 15,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        };
      case "middle":
      default:
        return {
          border: "2px solid #F5F5F5",
          borderRadius: 0,
          borderBottomColor: "#E2E2E2",
        };
    }
  };

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.accountInfo}
          </Title>
        }
        key="1"
      >
        {displayFields.map((item, index) => (
          <div style={getStyleBasedOnPosition(item?.position)} key={index}>
            <Row>
              <Col
                span={12}
                style={{
                  backgroundColor: "#F5F5F5",
                  padding: 10,
                  borderRadius: 0,
                }}
              >
                <Text strong>{item.name}</Text>
              </Col>
              <Col
                span={12}
                style={{
                  padding: 10,
                }}
              >
                <Text style={{ color: "#b8b8b8" }}>{item.value}</Text>
              </Col>
            </Row>
          </div>
        ))}
      </Panel>
    </Collapse>
  );
}

function PerformanceHistory(props) {
  const { accountDetails } = props;
  const displayFields = [
    {
      name: labelConfig.interestEarned,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                ${
                  accountDetails?.summary?.totalInterestEarned ||
                  accountDetails?.summary?.totalInterestEarned === 0
                    ? BOM.TruncateDecimal(accountDetails?.summary?.totalInterestEarned, 2)
                    : "-"
                }`,
      position: "top",
    },
    {
      name: labelConfig.totalDeposits,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                  ${
                    accountDetails?.summary?.totalDeposits ||
                    accountDetails?.summary?.totalDeposits === 0
                      ? BOM.TruncateDecimal(accountDetails?.summary?.totalDeposits, 2)
                      : "-"
                  }`,
      position: "bottom",
    },
  ];

  const getStyleBasedOnPosition = (position) => {
    switch (position.toLowerCase()) {
      case "top":
        return {
          border: "2px solid #F5F5F5",
          borderRadius: 15,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomColor: "#E2E2E2",
        };
      case "bottom":
        return {
          border: "2px solid #F5F5F5",
          borderRadius: 15,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        };
      case "middle":
      default:
        return {
          border: "2px solid #F5F5F5",
          borderRadius: 0,
          borderBottomColor: "#E2E2E2",
        };
    }
  };

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.performanceHistory}
          </Title>
        }
        key="1"
      >
        {displayFields.map((item, index) => (
          <div style={getStyleBasedOnPosition(item?.position)} key={index}>
            <Row>
              <Col
                span={12}
                style={{
                  backgroundColor: "#F5F5F5",
                  padding: 10,
                  borderRadius: 0,
                }}
              >
                <Text strong>{item.name}</Text>
              </Col>
              <Col
                span={12}
                style={{
                  padding: 10,
                }}
              >
                <Text style={{ color: "#b8b8b8" }}>{item.value}</Text>
              </Col>
            </Row>
          </div>
        ))}
      </Panel>
    </Collapse>
  );
}

function InterestDetails(props) {
  const { accountDetails } = props;
  const displayFields = [
    {
      name: labelConfig.totalWithdrawalsFees,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                ${
                  accountDetails?.summary?.totalWithdrawals ||
                  accountDetails?.summary?.totalWithdrawals === 0
                    ? accountDetails?.summary?.totalWithdrawals.toLocaleString()
                    : "-"
                }`,
      position: "top",
    },

    {
      name: labelConfig.interestEarned,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                  ${
                    accountDetails?.summary?.totalInterestEarned ||
                    accountDetails?.summary?.totalInterestEarned === 0
                      ? BOM.TruncateDecimal(accountDetails?.summary?.totalInterestEarned, 2)
                      : "-"
                  }`,
      position: "middle",
    },
    {
      name: labelConfig.interestPosted,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                  ${
                    accountDetails?.summary?.totalInterestPosted ||
                    accountDetails?.summary?.totalInterestPosted === 0
                      ? BOM.TruncateDecimal(accountDetails?.summary?.totalInterestPosted, 2)
                      : "-"
                  }`,
      position: "middle",
    },
    {
      name: labelConfig.lienBlockedAmount,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                  ${
                    accountDetails?.lienAmount || accountDetails?.lienAmount === 0
                      ? BOM.TruncateDecimal(accountDetails?.lienAmount, 2)
                      : "-"
                  }`,
      position: "middle",
    },
    {
      name: labelConfig.earnedInterestNotPosted,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                  ${
                    accountDetails?.summary?.interestNotPosted ||
                    accountDetails?.summary?.interestNotPosted === 0
                      ? BOM.TruncateDecimal(accountDetails?.summary?.interestNotPosted, 2)
                      : "-"
                  }`,
      position: "middle",
    },
    {
      name: labelConfig.nominalInterestrate,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                  ${
                    accountDetails?.nominalAnnualInterestRate ||
                    accountDetails?.nominalAnnualInterestRate === 0
                      ? `${accountDetails?.nominalAnnualInterestRate}%`
                      : "-"
                  }`,
      position: "middle",
    },
    {
      name: labelConfig.interestCompoundingPeriod,
      value: accountDetails?.interestCompoundingPeriodType?.value
        ? accountDetails?.interestCompoundingPeriodType?.value
        : "-",
      position: "middle",
    },

    {
      name: labelConfig.interestPostingPeriod,
      value: accountDetails?.interestPostingPeriodType?.value
        ? accountDetails?.interestPostingPeriodType?.value
        : "-",
      position: "middle",
    },
    {
      name: labelConfig.interestCalculatedUsing,
      value: accountDetails?.interestCalculationType?.value
        ? accountDetails?.interestCalculationType?.value
        : "-",
      position: "middle",
    },
    {
      name: labelConfig.daysInYear,
      value: accountDetails?.interestCalculationDaysInYearType?.value
        ? accountDetails?.interestCalculationDaysInYearType?.value
        : "-",
      position: "middle",
    },
    {
      name: labelConfig.withdrawalFee,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                  ${
                    accountDetails?.withdrawalFee?.amount ||
                    accountDetails?.withdrawalFee?.amount === 0
                      ? `${accountDetails?.withdrawalFee?.amount}%`
                      : "-"
                  }`,
      position: "middle",
    },
    {
      name: labelConfig.lastActiveTransactionDate,
      value: `${
        accountDetails?.lastActiveTransactionDate
          ? BOM.DateTime(accountDetails?.lastActiveTransactionDate, "only-date")
          : "-"
      }`,
      position: "middle",
    },
    {
      name: labelConfig.annualFee,
      value: `${accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}
                ${
                  accountDetails?.annualFee?.amount || accountDetails?.annualFee?.amount === 0
                    ? BOM.TruncateDecimal(accountDetails?.annualFee?.amount, 2)
                    : "-"
                }
                
                ${
                  accountDetails?.annualFee?.dueDate
                    ? ` on  ${BOM.DateTimeWithoutYear(
                        accountDetails?.annualFee?.dueDate,
                        "only-date",
                      )}`
                    : "-"
                }`,
      position: "middle",
    },

    {
      name: labelConfig.enforceMinimumBalance,
      value: accountDetails.enforceMinRequiredBalance ? "True" : "False",
      position: "middle",
    },
    {
      name: labelConfig.minimumBalance,
      value: `${
        accountDetails.minRequiredBalance || accountDetails.minRequiredBalance === 0
          ? BOM.TruncateDecimal(accountDetails.minRequiredBalance, 2)
          : "-"
      }`,
      position: "middle",
    },
    {
      name: labelConfig.interestRecalculationDate,
      value: `${
        accountDetails?.summary?.lastInterestCalculationDate
          ? BOM.DateTime(accountDetails?.summary?.lastInterestCalculationDate, "only-date")
          : "-"
      }`,
      position: "middle",
    },
    {
      name: labelConfig.subStatus,
      value: accountDetails?.subStatus?.value
        ? handleFlgSubStatus(accountDetails?.subStatus?.value)
        : "-",
      position: "middle",
    },
    {
      name: labelConfig.balanceOnHold,
      value: accountDetails?.savingsAmountOnHold
        ? BOM.TruncateDecimal(accountDetails?.savingsAmountOnHold, 2)
        : "--",
      href: accountDetails?.savingsAmountOnHold ? "/savings-account-action" : undefined,
      position: "middle",
    },
    {
      name: labelConfig.reasonForBlockHold,
      value: accountDetails?.reasonForBlock ? accountDetails?.reasonForBlock : "--",
      position: "bottom",
    },
  ];

  const getStyleBasedOnPosition = (position) => {
    switch (position.toLowerCase()) {
      case "top":
        return {
          border: "2px solid #F5F5F5",
          borderRadius: 15,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomColor: "#E2E2E2",
        };
      case "bottom":
        return {
          border: "2px solid #F5F5F5",
          borderRadius: 15,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        };
      case "middle":
      default:
        return {
          border: "2px solid #F5F5F5",
          borderRadius: 0,
          borderBottomColor: "#E2E2E2",
        };
    }
  };

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.financialInfo}
          </Title>
        }
        key="1"
      >
        {displayFields.map((item, index) => {
          const isLink = item.href;
          return (
            <div style={getStyleBasedOnPosition(item?.position)} key={index}>
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>{item.name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  {!isLink && <Text style={{ color: "#b8b8b8" }}>{item.value}</Text>}
                  {isLink && (
                    <Link
                      to={item.href}
                      state={{ actionLabel: "hold items", id: accountDetails.id }}
                      style={{ color: "#92428b", textDecoration: "underline" }}
                    >
                      {item.value}
                    </Link>
                  )}
                </Col>
              </Row>
            </div>
          );
        })}
      </Panel>
    </Collapse>
  );
}
